import React from 'react';
import PropTypes from 'prop-types';
import NewsArticleGrid from './NewsArticleGrid';

const NewsArticleRelated = ({
    ministryGroup = [],
    newsArticles = [],
    numberOfArticlesToShow = 2,
    references,
    relatedNewsContentCategory = [],
    title,
    nodeTypeAlias = 'NewsArticleRelated',
    width,
    hardWidth
}) => {
    if (newsArticles?.length === 0) {
        return null;
    }

    return (
        <NewsArticleGrid
            articleCategory={relatedNewsContentCategory}
            heading={title}
            ministryGroup={ministryGroup}
            initialLoadCount={numberOfArticlesToShow}
            newsArticles={newsArticles}
            references={references}
            nodeTypeAlias={nodeTypeAlias}
            width={width}
            hardWidth={hardWidth}
        />
    );
};

NewsArticleRelated.propTypes = {
    ministryGroup: PropTypes.arrayOf(PropTypes.string),
    newsArticles: PropTypes.arrayOf(PropTypes.object),
    nodeTypeAlias: PropTypes.string,
    numberOfArticlesToShow: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    references: PropTypes.object,
    relatedNewsContentCategory: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string
};

export default NewsArticleRelated;
